import { useSelector } from 'react-redux';
import { SimpleSelectOptionFormatter, useArrayToSimpleSelectOption } from '../components';
import { reprocessParametersSelector } from '../state';

const formatter: SimpleSelectOptionFormatter = {
  type: 'translation',
  translationIdBase: 'reprocess.type',
  sort: 'asc',
};

const useReprocessTypeSelect = (category?: string) => {
  const parameters = useSelector(reprocessParametersSelector);
  const types = parameters.data?.types.filter(item =>
    category
      ? item.category.toLocaleLowerCase() === category
      : item.category.toLocaleLowerCase() !== 'interface'
  );
  const options = useArrayToSimpleSelectOption(types?.map(item => item.type) || [], formatter);
  const categoryOptions = types || [];
  return { options, categoryOptions, loading: parameters.loading };
};

export default useReprocessTypeSelect;
